import { ReactNode } from 'react';
import classNames from 'classnames';
import { ButtonPanel, IButtonPanelProps } from './ButtonPanel';

export type IActionVariant = "decisions" | "material";

/**We will expose this one to the host */
export interface IDialogActionsProps extends IButtonPanelProps {
  children?: ReactNode;
}

export function DialogActions({ children, className, actions, style, variant }: IDialogActionsProps) {
  const rootClasses = classNames('dp-dialog-actions', className);

  return children ? (
    <div className={rootClasses} style={style}>
      {children}
    </div>
  ) : actions?.length ? (
    <ButtonPanel className={rootClasses} style={style} actions={actions} variant={variant} />
  ) : null;
}
